import _extends from "@babel/runtime/helpers/esm/extends";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "onClickOutside", "ignoreRefs", "className"];
import React, { forwardRef, useMemo, useRef } from 'react';
import { useClickOutside, useCombinedRefs } from "../../hooks";
import noop from "../../utils/noop";
export var ClickOutside = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      _ref$onClickOutside = _ref.onClickOutside,
      onClickOutside = _ref$onClickOutside === void 0 ? noop : _ref$onClickOutside,
      _ref$ignoreRefs = _ref.ignoreRefs,
      ignoreRefs = _ref$ignoreRefs === void 0 ? [] : _ref$ignoreRefs,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  var rootRef = useRef();
  var combineRef = useCombinedRefs(ref, rootRef);
  var ignoreClicksInsideRefs = useMemo(function () {
    return [rootRef].concat(_toConsumableArray(ignoreRefs));
  }, [ignoreRefs]);
  useClickOutside({
    active: true,
    ignoreClicksInsideRefs: ignoreClicksInsideRefs,
    handler: onClickOutside
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: combineRef,
    className: className
  }, props), children);
});